import styled, { css } from "styled-components";
import { media } from "src/utils/media";
import i18n from "i18next";

const titleFontFamily =
  i18n.language === "ko" ? "Pretendard, Inter" : "Inter, Pretendard";
const bodyFontFamily =
  i18n.language === "ko" ? "Pretendard, Inter" : "Inter, Pretendard";

const Pre = styled.pre`
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: keep-all;
`;

const h1CSS = css`
  font-family: ${titleFontFamily};
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 84px;
  letter-spacing: -0.02em;
  ${media.mobile`
    font-size: 36px;
    line-height: 48px;
  `}
`;

export const H1 = styled.div`
  ${h1CSS}
`;

export const H1Pre = styled(Pre)`
  ${h1CSS}
`;

const h2CSS = css`
  font-family: ${titleFontFamily};
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 72px;
  letter-spacing: -0.01em;
  ${media.mobile`
    font-size: 28px;
    line-height: 40px;
  `}
`;

export const H2 = styled.div`
  ${h2CSS}
`;

export const H2Pre = styled(Pre)`
  ${h2CSS}
`;

const h3CSS = css`
  font-family: ${titleFontFamily};
  font-style: normal;
  font-weight: bold;
  font-size: 34px;
  line-height: 50px;
  letter-spacing: -0.005em;
  ${media.mobile`
    font-size: 20px;
    line-height: 30px;
  `}
`;

export const H3 = styled.div`
  ${h3CSS}
`;

export const H3Pre = styled(Pre)`
  ${h3CSS}
`;

export const H4 = styled.div`
  font-family: ${titleFontFamily};
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: -0.005em;
  ${media.mobile`
    font-size: 16px;
    line-height: 28px;
  `}
`;

const body1CSS = css`
  font-family: ${bodyFontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 32px;
  ${media.mobile`
    font-size: 15px;
    line-height: 23px;
  `}
`;

export const Body1 = styled.div`
  ${body1CSS}
`;

export const Body1Pre = styled(Pre)`
  ${body1CSS}
`;

const body2CSS = css`
  font-family: ${bodyFontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.05em;
  ${media.mobile`
    font-size: 13px;
    line-height: 20px;
  `}
`;

export const Body2 = styled.div`
  ${body2CSS};
`;

export const Body2A = styled.a`
  ${body2CSS};
`;

export const Body2Pre = styled(Pre)`
  ${body2CSS};
`;

const captionCSS = css`
  font-family: ${bodyFontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0.001em;
  ${media.mobile`
    font-size: 12px;
    line-height: 18px;
  `}
`;

export const Caption = styled.div`
  ${captionCSS}
`;

export const CaptionPre = styled(Pre)`
  ${captionCSS}
`;

export const GNB = styled.div`
  font-family: ${titleFontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 29px;
  letter-spacing: 0.04em;
  ${media.mobile`
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
  `}
`;

export const GNBSub = styled.div`
  font-family: ${titleFontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
`;

export const buttonCSS = css`
  font-family: ${titleFontFamily};
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.02em;
  ${media.mobile`
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 22px;
  `}
`;

export const ButtonA = styled.a`
  ${buttonCSS}
`;

export const Button = styled.span`
  ${buttonCSS}
`;

export const Badge = styled.div`
  font-family: ${titleFontFamily};
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const Bold10 = styled.div``;
